import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

const SUCURSALES = [
  'Central Asunción (Matriz)',
  'Ciudad Del Este',
  'Pedro Juan Caballero',
  'Saltos del Guairá',
  'Santa Rita',
  'Santa Rosa',
  'Campo 9',
  'Katueté',
];

export function Coverage() {
  return (
    <Section id="coverage">
      <SectionTitle subtitle="Presencia operativa en los principales puntos del país.">
        Cobertura Nacional
      </SectionTitle>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {SUCURSALES.map((sucursal, i) => (
          <motion.div
            key={sucursal}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.3, delay: i * 0.05 }}
            whileHover={{ y: -4 }}
            className="flex items-center gap-3 rounded-xl border border-white/[0.06] bg-white/[0.02] px-4 py-4 transition-colors hover:bg-white/[0.04]"
          >
            <MapPin className="h-5 w-5 shrink-0 text-primary" strokeWidth={1.5} aria-hidden />
            <span className="text-sm font-medium text-slate-300">{sucursal}</span>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
